module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    staticStyle: {
      "border-bottom": "0"
    },
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("销售交易")])], 1), _vm._v(" "), _c('el-form', {
    ref: "topForm",
    attrs: {
      "inline": true,
      "model": _vm.topForm
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "13%",
      "margin-bottom": "1%"
    },
    attrs: {
      "placeholder": "分部编号"
    },
    on: {
      "change": function($event) {
        _vm.getKisok()
      }
    },
    model: {
      value: (_vm.topForm.branchId),
      callback: function($$v) {
        _vm.$set(_vm.topForm, "branchId", $$v)
      },
      expression: "topForm.branchId"
    }
  }, _vm._l((_vm.branchList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.branchName,
        "value": item.branchId
      }
    })
  }), 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "13%",
      "margin-right": "2%"
    },
    attrs: {
      "placeholder": "机器编号"
    },
    model: {
      value: (_vm.topForm.kioskNo),
      callback: function($$v) {
        _vm.$set(_vm.topForm, "kioskNo", $$v)
      },
      expression: "topForm.kioskNo"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部售货机",
      "value": ""
    }
  }, [_vm._v("全部售货机")]), _vm._v(" "), _vm._l((_vm.kioskList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.deviceName,
        "value": item.deviceId
      }
    })
  })], 2), _vm._v(" "), _c('el-select', {
    staticClass: "m-1",
    staticStyle: {
      "width": "13%",
      "margin-right": "2%"
    },
    attrs: {
      "placeholder": "交易状态"
    },
    model: {
      value: (_vm.topForm.orderStatus),
      callback: function($$v) {
        _vm.$set(_vm.topForm, "orderStatus", $$v)
      },
      expression: "topForm.orderStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部状态",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "正常",
      "value": "ok"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "异常",
      "value": "err"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    staticClass: "m-1",
    staticStyle: {
      "width": "13%",
      "margin-right": "2%"
    },
    attrs: {
      "placeholder": "交易类型"
    },
    model: {
      value: (_vm.topForm.orderType),
      callback: function($$v) {
        _vm.$set(_vm.topForm, "orderType", $$v)
      },
      expression: "topForm.orderType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部类型",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "销售",
      "value": "sale"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预订",
      "value": "reserve"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "领赠",
      "value": "gift"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "input-with-select m-1",
    staticStyle: {
      "margin-right": "2%",
      "width": "15%"
    },
    attrs: {
      "placeholder": "请输入订单信息"
    },
    model: {
      value: (_vm.topForm.orderId),
      callback: function($$v) {
        _vm.$set(_vm.topForm, "orderId", $$v)
      },
      expression: "topForm.orderId"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.getOrder()
      }
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('el-date-picker', {
    staticClass: "m-1",
    staticStyle: {
      "width": "auto",
      "margin-bottom": "1%"
    },
    attrs: {
      "type": "datetimerange",
      "align": "right",
      "clearable": false,
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.topForm.datatime),
      callback: function($$v) {
        _vm.$set(_vm.topForm, "datatime", $$v)
      },
      expression: "topForm.datatime"
    }
  }), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "5%"
    }
  }, [_c('el-button', {
    staticClass: "m-1",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.orderExcel()
      }
    }
  }, [_vm._v("导出订单")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "5%"
    }
  }, [_c('el-button', {
    staticClass: "m-1",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.orderProExcel()
      }
    }
  }, [_vm._v("导出商品订单")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "5%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "3%"
    },
    attrs: {
      "type": "primary",
      "icon": "search",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.getOrder()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "5%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "3%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-card', [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header",
      "shadow": "hover"
    },
    slot: "header"
  }, [_c('span', [_vm._v("交易流水")])]), _vm._v(" "), _c('el-table', {
    ref: "tradeTable",
    attrs: {
      "data": _vm.orders.slice((_vm.page - 1) * 10, _vm.page * 10),
      "border": "",
      "row-key": "orderNo"
    },
    on: {
      "expand-change": _vm.tradeDetail
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-table', {
          attrs: {
            "data": _vm.orderTrans.filter(function (o) { return o.orderNo === props.row.orderNo; })
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "productName",
            "label": "商品名称",
            "width": "180"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "SKU",
            "label": "SKU",
            "width": "100"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price",
            "label": "单价"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                        ￥" + _vm._s(scope.row.payPrice / 100) + "\n                                    ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price",
            "label": "支付金额"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                        ￥" + _vm._s(scope.row.payPrice / 100) + "\n                                    ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "商品状态"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.orders[props.$index].orderStatus === 'open') ? _c('span', [_vm._v("处理中")]) : _vm._e(), _vm._v(" "), (_vm.orders[props.$index].orderStatus === 'paid') ? _c('span', [_vm._v("已支付")]) : _vm._e(), _vm._v(" "), (_vm.orders[props.$index].orderStatus === 'ok') ? _c('span', [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (_vm.orders[props.$index].orderStatus === 'cancel') ? _c('span', [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.orders[props.$index].orderStatus === 'bbox') ? _c('span', [_vm._v("待提货")]) : _vm._e(), _vm._v(" "), (_vm.orders[props.$index].orderStatus === 'deliver') ? _c('span', [_vm._v("取货中")]) : _vm._e(), _vm._v(" "), (_vm.orders[props.$index].orderStatus === 'err' && scope.row.outStatus == 2) ? _c('span', {
                staticStyle: {
                  "color": "red"
                }
              }, [_vm._v("异常")]) : _vm._e(), _vm._v(" "), (_vm.orders[props.$index].orderStatus === 'err' && scope.row.outStatus == 1) ? _c('span', [_vm._v("正常")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "商品交易类型",
            "width": "110"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.orders[props.$index].orderType === 'sale') ? _c('span', [_vm._v("销售")]) : (_vm.orders[props.$index].orderType === 'reserve') ? _c('span', [_vm._v("预订")]) : _c('span', [_vm._v("赠品")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "align": "center",
            "label": "视频"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                        -\n                                    ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "照片",
            "width": "110"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                        -\n                                    ")]
            }
          }])
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "branchName",
      "label": "分部"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "kioskNo",
      "label": "设备ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "deviceName",
      "label": "机器名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "orderNo",
      "label": "交易号",
      "width": "155px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "customerID",
      "label": "持卡人",
      "width": "155px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "TotalCount",
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          style: (scope.row.TotalCount == scope.row.OKCount ? '' : (scope.row.TotalCount > scope.row.OKCount ? 'color: red' : 'totalCount'))
        }, [_vm._v(_vm._s(scope.row.OKCount) + "/" + _vm._s(scope.row.TotalCount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "订单金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            ￥" + _vm._s(scope.row.subtotal / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "支付金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            ￥" + _vm._s(scope.row.chargeAmount / 100) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "paymentMethod",
      "label": "支付方式",
      "width": "170px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.paymentMethod == 'wechat') ? _c('span', [_vm._v("微信")]) : _vm._e(), _vm._v(" "), (scope.row.paymentMethod == 'alipay') ? _c('span', [_vm._v("支付宝")]) : _vm._e(), _vm._v(" "), (scope.row.paymentMethod == 'score:1983') ? _c('span', [_vm._v("1983积分支付")]) : _vm._e(), _vm._v(" "), (scope.row.paymentMethod == 'unionPay') ? _c('span', [_vm._v("银联")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createTime",
      "label": "交易时间",
      "formatter": _vm.formatter,
      "width": "155px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "155px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.goOrderInfo(scope.row)
            }
          }
        }, [_vm._v("查看详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orders.length > 10),
      expression: "orders.length>10"
    }],
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": " total,prev, pager, next , jumper",
      "current-page": _vm.page,
      "total": _vm.orders.length
    },
    on: {
      "current-change": _vm.table
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "监控/出货视频",
      "fullscreen": "",
      "visible": _vm.VideoModel,
      "width": "70%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.VideoModel = $event
      },
      "closed": function($event) {
        _vm.videoClose()
      }
    }
  }, [_c('div', {
    staticClass: "video-dialog"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.VideoUrl != ''),
      expression: "VideoUrl != ''"
    }],
    staticClass: "video"
  }, [_c('p', [_vm._v("监控视频")]), _vm._v(" "), _c('video', {
    attrs: {
      "id": "Video",
      "src": _vm.VideoUrl,
      "autoplay": "",
      "controls": "controls"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ExVideoUrl != ''),
      expression: "ExVideoUrl != ''"
    }],
    staticClass: "video"
  }, [_c('p', [_vm._v("出货视频")]), _vm._v(" "), _c('video', {
    attrs: {
      "id": "VideoPath",
      "src": _vm.ExVideoUrl,
      "autoplay": "",
      "controls": "controls"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.BoxVideoUrl != ''),
      expression: "BoxVideoUrl != ''"
    }],
    staticClass: "video"
  }, [_c('p', [_vm._v("BBox视频")]), _vm._v(" "), _c('video', {
    attrs: {
      "id": "VideoBox",
      "src": _vm.BoxVideoUrl,
      "autoplay": "",
      "controls": "controls"
    }
  })])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "fullscreen": "",
      "visible": _vm.pictureModel,
      "width": "70%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.pictureModel = $event
      }
    }
  }, [_c('div', {
    staticClass: "pic-dialog"
  }, [_c('div', {
    staticClass: "boximg"
  }, [_c('p', [_vm._v("存入前状态")]), _c('img', {
    attrs: {
      "src": _vm.BoxImageUrlBD
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boximg"
  }, [_c('p', [_vm._v("存入后状态")]), _c('img', {
    attrs: {
      "src": _vm.BoxImageUrlAD
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pic-dialog"
  }, [_c('div', {
    staticClass: "boximg"
  }, [_c('p', [_vm._v("开门前状态")]), _c('img', {
    attrs: {
      "src": _vm.BoxImageUrlBO
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boximg"
  }, [_c('p', [_vm._v("关门后状态")]), _c('img', {
    attrs: {
      "src": _vm.BoxImageUrlAC
    }
  })])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03304070!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/order/trade.vue
// module id = 1026
// module chunks = 2